/**
 * Role Constants Configuration
 * 
 * This file defines role names as constants to avoid hard-coding role IDs
 * Role IDs can change in production, but role names remain stable
 * Always use role names for business logic instead of role IDs
 */

export const ROLE_NAMES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  FLEET_ADMIN: 'Fleet Admin',
  CUSTOMER_SUPPORT: 'Customer Support',
  STORE_ADMIN: 'Store Admin',
  STORE_USER: 'Store User',
  SUPER_USER: 'Super User',
  INFLUENCER: 'Influencer',
} as const;

/**
 * Role Hierarchy & Access Control
 * Defines what roles can create which roles
 * Update this based on business requirements, not role IDs
 */
export const ROLE_CREATION_HIERARCHY = {
  [ROLE_NAMES.SUPER_ADMIN]: ['all'], // Can create all roles
  [ROLE_NAMES.ADMIN]: [
    ROLE_NAMES.FLEET_ADMIN,
    ROLE_NAMES.CUSTOMER_SUPPORT,
    ROLE_NAMES.STORE_ADMIN,
    ROLE_NAMES.STORE_USER,
    ROLE_NAMES.SUPER_USER,
    ROLE_NAMES.INFLUENCER,
  ], // Admin cannot create Super Admin
  [ROLE_NAMES.FLEET_ADMIN]: [ROLE_NAMES.STORE_USER], // Fleet Admin can only create Store Users
  [ROLE_NAMES.STORE_ADMIN]: [ROLE_NAMES.STORE_USER],
} as const;

/**
 * Roles that require store assignment
 */
export const ROLES_REQUIRING_STORES = [
  ROLE_NAMES.STORE_USER,
  ROLE_NAMES.STORE_ADMIN,
] as const;


